export default "__VITE_ASSET__5LptEnCq__"